import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle, AlertCircle } from 'lucide-react';
import './ForgotPassword.css';

interface ForgotPasswordProps {}

export const ForgotPassword: React.FC<ForgotPasswordProps> = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const response = await fetch('/api/password-reset/request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (data.success) {
        setIsSuccess(true);
        setMessage(data.message);
      } else {
        setIsSuccess(false);
        setMessage(data.error || 'Failed to send password reset email');
      }
    } catch (error) {
      setIsSuccess(false);
      setMessage('Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="forgot-password-container" >
      <div className="forgot-password-card">
        <div className="forgot-password-header">
          <div className="header-content">
            {/* <div className="icon-container">
              <Mail size={32} className="mail-icon" />
            </div> */}
            <h1 className="title">Forgot Password?</h1>
            <p className="subtitle">
              Enter your email address and we'll send you a link to reset your
              password.
            </p>
          </div>
        </div>

        {!isSuccess ? (
          <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter your email address"
                className="form-input"
                required
                disabled={isLoading}
              />
            </div>

            {message && (
              <div className={`message ${isSuccess ? 'success' : 'error'}`}>
                {isSuccess ? (
                  <CheckCircle size={20} className="message-icon" />
                ) : (
                  <AlertCircle size={20} className="message-icon" />
                )}
                <span>{message}</span>
              </div>
            )}

            <button
              type="submit"
              className="btn-primary btn-full"
              disabled={isLoading || !email.trim()}
              style={{marginTop: '1.5rem'}}
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        ) : (
          <div className="success-message">
            <div style={{display:'flex',flexDirection: 'row',justifyContent:'center'}}>
            <CheckCircle size={48} className="success-icon" />
            </div>
            <h2>Check Your Email</h2>
            <p>{message}</p>
            <p className="email-note">
              We've sent a password reset link to <strong>{email}</strong>
            </p>
            <div className="action-buttons">
              {/* <button
                onClick={() => {
                  setIsSuccess(false);
                  setMessage('');
                  setEmail('');
                }}
                className="btn-primary btn-auto"
                style={{marginTop: '1.5rem'}}
              >
                Send Another Email
              </button> */}
              <button
                onClick={handleBackToLogin}
                className="btn-primary btn-auto"
              >
                BACK TO LOGIN
              </button>
            </div>
          </div>
        )}

        <div className="forgot-password-footer">
          <p>
            Remember your password?{' '}
            <Link to="/login" className="login-link">
              Sign in here
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
